import React from "react";
import "./style.css";
import ScaleLoader from "react-spinners/ScaleLoader";
import { connect } from "react-redux";
import BrandLogo from "../../../components/BrandLogo/BrandLogo";

function OverLayLoader(props) {
  const { show, alwaysShow } = props;
  const visible = Boolean(show || alwaysShow);

  return (
    <div
      className="dl-loader"
      style={{ display: visible ? "flex" : "none" }}
      role="status"
      aria-live="polite"
      aria-busy={visible}
      aria-hidden={!visible}
    >
      <div className="dl-loader__fx" aria-hidden="true">
        <span className="dl-loader__orb dl-loader__orb--a" />
        <span className="dl-loader__orb dl-loader__orb--b" />
        <span className="dl-loader__grid" />
      </div>

      <div className="dl-loader__card">
        <div className="dl-loader__brand">
          <BrandLogo variant="light" compact className="dl-loader__logo" />
          <span className="dl-loader__badge">Dealers</span>
        </div>

        <ScaleLoader
          height={28}
          width={4}
          radius={2}
          margin={3}
          color="#c4a052"
          speedMultiplier={0.85}
        />

        <p className="dl-loader__eyebrow">Processing</p>
        <p className="dl-loader__title">Connecting to your trade desk…</p>
        <p className="dl-loader__hint">Please wait a moment</p>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  show: state.loader.show,
});

export default connect(mapStateToProps)(OverLayLoader);
